import { FC, useEffect, useState } from 'react';
import { StoreGroupsTabItemProps } from './StoreGroupsTabItemProps.types';
import { Store } from '@/types/stores.types';
import _ from 'lodash/';
import { StoreGroupType } from '@/context/context.types';
import styles from './StoreGroupsTabItem.module.css';
import { ModifierStoreGroupTable } from './internal/StoreGroupTable/ModifierStoreGroupTable';

function createGroups(stores: Store[]): StoreGroup[] {
  const newArray = [] as StoreGroup[];
  const groups = _.groupBy(stores, 'groupName');
  const plainMap = _.toPlainObject(groups);

  _.forOwn(plainMap, (value, key) => {
    newArray.push({ name: key, stores: value });
  });

  return newArray;
}

export interface StoreGroup {
  id?: string;
  name?: string;
  cod?: string;
  stores: Store[];
}

const ModifierStoreGroupsTabItem: FC<StoreGroupsTabItemProps> = ({ stores, onStoresSelectionChange }) => {
  const [groups, setGroups] = useState<StoreGroup[]>(createGroups(stores));

  const [localSelectedStores, setLocalSelectedStores] = useState<Map<string, string[]>>(new Map<string, string[]>());

  useEffect(() => {
    setGroups(createGroups(stores));
  }, [stores]);

  const onSelectStore = (groupName: string, storeNos: string[]) => {
    const newSelectedStores = localSelectedStores;
    newSelectedStores.set(groupName, storeNos);
    setLocalSelectedStores(newSelectedStores);

    const storeGroup = [] as StoreGroupType[];
    const groupByName = _.groupBy(stores, 'groupName');

    newSelectedStores.forEach((value, key) => {
      if (value.length > 0) {
        storeGroup.push({
          storeGroup: key,
          storeGroupId: stores.find((store) => store.groupName === key)?.groupId,
          stores: value,
          storeCount: groupByName[key].length,
        });
      }
    });

    onStoresSelectionChange({
      origin: 'tab-stores-groups',
      storeGroups: storeGroup,
    });
  };

  return (
    <>
      {groups.map((group) => (
        <div key={group.name} className={styles.accordions}>
          <ModifierStoreGroupTable
            key={group.name}
            name={group.name}
            stores={group.stores}
            onStoresSelectionChange={(storeList) => onSelectStore(group.name || '', storeList)}
          />
        </div>
      ))}
    </>
  );
};

export default ModifierStoreGroupsTabItem;
